/**
 * Messages of the overlay primitives and the existing kit components (owner ui-layers).
 * `de` must have every key of `en` (type-checked below). `{name}` placeholders are interpolated;
 * keys ending in `_one` / `_other` are chosen by the `count` variable.
 */
export const layersEn = {
  'ui.close': 'Close',
  'ui.dismiss': 'Dismiss',
  'ui.loading': 'Loading',
  'ui.cancel': 'Cancel',
  'ui.confirm': 'Confirm',
  'ui.delete': 'Delete',
  'ui.remove': 'Remove',
  'ui.removeFilter': 'Remove filter',
  'ui.unassigned': 'Unassigned',
  'ui.source': 'Source: {label}',
  'ui.fieldType': 'Field type {glyph}',
  'ui.unsavedChanges': 'Unsaved changes',
  'ui.more': 'More',
  'ui.select.placeholder': 'Select…',
  'ui.discard.title': 'Discard unsaved changes?',
  'ui.discard.body': 'What you entered here will be lost.',
  'ui.discard.keep': 'Keep editing',
  'ui.discard.confirm': 'Discard',
  'ui.confirm.typeToConfirm': 'Type {name} to confirm',
  'ui.confirm.typeLabel': 'Name to confirm',
  'ui.toast.region': 'Notifications',
  'ui.toast.undo': 'Undo',
  'ui.toast.undone': 'Undone',
  'ui.toast.loading': 'Working…',
  'ui.toast.failed': 'Something went wrong',
  'ui.sheet.drag': 'Drag down to close',
  'ui.menu.submenu': '{label} submenu',
} as const;

export type LayersMessageKey = keyof typeof layersEn;

export const layersDe: Record<LayersMessageKey, string> = {
  'ui.close': 'Schließen',
  'ui.dismiss': 'Ausblenden',
  'ui.loading': 'Wird geladen',
  'ui.cancel': 'Abbrechen',
  'ui.confirm': 'Bestätigen',
  'ui.delete': 'Löschen',
  'ui.remove': 'Entfernen',
  'ui.removeFilter': 'Filter entfernen',
  'ui.unassigned': 'Nicht zugewiesen',
  'ui.source': 'Quelle: {label}',
  'ui.fieldType': 'Feldtyp {glyph}',
  'ui.unsavedChanges': 'Ungespeicherte Änderungen',
  'ui.more': 'Mehr',
  'ui.select.placeholder': 'Auswählen…',
  'ui.discard.title': 'Ungespeicherte Änderungen verwerfen?',
  'ui.discard.body': 'Ihre Eingaben hier gehen verloren.',
  'ui.discard.keep': 'Weiter bearbeiten',
  'ui.discard.confirm': 'Verwerfen',
  'ui.confirm.typeToConfirm': 'Zum Bestätigen {name} eingeben',
  'ui.confirm.typeLabel': 'Name zur Bestätigung',
  'ui.toast.region': 'Benachrichtigungen',
  'ui.toast.undo': 'Rückgängig',
  'ui.toast.undone': 'Rückgängig gemacht',
  'ui.toast.loading': 'Wird ausgeführt…',
  'ui.toast.failed': 'Etwas ist schiefgelaufen',
  'ui.sheet.drag': 'Zum Schließen nach unten ziehen',
  'ui.menu.submenu': 'Untermenü {label}',
};
